

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


  var Main = function( )
  {
    slickInit();
  }

  var slickInit = function() {
    var currentIndex;

    //サムネール
    $('.char-nav')
      .slick({
        infinite: false,
        // slidesToShow: 21,
        // slidesToScroll: 21,
        useCSS: false,
        focusOnSelect: true,
        draggable: false,
        speed: 0,
        arrows: false,
        waitForAnimate: false,
        asNavFor: '.char-slider__container', //thumbnailクラスのナビゲーション
      })
      .on('afterChange', function(slick, currentSlide){

        currentIndex = $('.slick-active').index() + 1;
        $('.char-slider__bg').removeClass('arther other angels');

        if(currentIndex == 1){
        }else if(currentIndex == 2){
          $('.char-slider__bg').addClass('arther');
        }else if(currentIndex >= 3 && currentIndex <= 6){
        }else if(currentIndex >= 7 && currentIndex <= 15){
          $('.char-slider__bg').addClass('arther');
        }else if(currentIndex == 16){
          $('.char-slider__bg').addClass('other');
        }else if(currentIndex >= 17 && currentIndex <= 20){
          $('.char-slider__bg').addClass('angels');
        }
      });
    //キャラクター
    $('.char-slider__container')
      .slick({
        infinite: false,
        easing: 'ease-in-out',
        // fade: true,
        speed: 400,
        waitForAnimate: false,
        asNavFor: '.char-nav',
        // arrows: false,
        //tracking効かない
        // prevArrow: '<a class="slick-prev js-tracking" href="#" data-tracking="切り替え,キャラクター立ち絵,前へ">前へ</a>',
        // nextArrow: '<a class="slick-next js-tracking" href="#" data-tracking="切り替え,キャラクター立ち絵,次へ">次へ</a>',
      });
  }

//------------------------------------------------------------------------------------------------------------------------------


  window.requestAnimationFrame =  window.requestAnimationFrame ||
                  window.webkitRequestAnimationFrame ||
                  function( func ){ return setTimeout( func , 1000/60 ) ; } ;


  window.cancelAnimationFrame =   window.cancelAnimationFrame ||
                  window.webkitCancelAnimationFrame ||
                  function( id ){ clearTimeout( id ) ; } ;


  document.readyState === "complete"
    ? setTimeout( function(){ new Main( ) ; } , 1 )
    : document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
